/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleSearchResult } from './APIArticleSearchResult';
import {
    APIArticleSearchResultFromJSON,
    APIArticleSearchResultFromJSONTyped,
    APIArticleSearchResultToJSON,
} from './APIArticleSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIArticleSearchResponse
 */
export interface APIArticleSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIArticleSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIArticleSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIArticleSearchResult>}
     * @memberof APIArticleSearchResponse
     */
    results: Array<APIArticleSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIArticleSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIArticleSearchResponse interface.
 */
export function instanceOfAPIArticleSearchResponse(value: object): value is APIArticleSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIArticleSearchResponseFromJSON(json: any): APIArticleSearchResponse {
    return APIArticleSearchResponseFromJSONTyped(json, false);
}

export function APIArticleSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIArticleSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIArticleSearchResponseToJSON(value?: APIArticleSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIArticleSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

